var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Subject } from "rxjs";
import { IdBuilding } from "../../../constants/IdBuilding";
import { IdOrientation } from "../../../constants/IdOrientation";
import { GetFenceCornerPillarIso } from "../../../graphics/fence/GetFenceCornerPillarIso";
import { GetFencePieceIso } from "../../../graphics/fence/GetFencePieceIso";
import { GetFencePillarIso } from "../../../graphics/fence/GetFencePillarIso";
import { selectBuildingInfoByTypeId } from "../../../selectors/selectExistingBuildingInfo";
import { selectExpansionInfo } from "../../../selectors/selectExpansionInfo";
import { IdAssetBundleCore } from "../../loading/IdAssetBundleCore";
import { actionBuildingsSelect } from "../buildings/actionBuildings";
import { LayerPlayerBaseSurrounding, } from "./LayerPlayerBaseSurrounding";
var LayerPlayerBaseFence = /** @class */ (function (_super) {
    __extends(LayerPlayerBaseFence, _super);
    function LayerPlayerBaseFence() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.update$ = new Subject();
        _this.getIsoObject = function (container) {
            var baseSetup = _this.props.expansionInfo.baseSetup;
            var exp = _this.getExpansionPartInfoById(container.name);
            exp.x -= 1;
            exp.y -= 1;
            var xExtent = 0;
            var yExtent = 0;
            // Multiplying by 4, because of 4 directions
            // We need to make ID unique
            exp.id *= 4;
            switch (exp.orientation) {
                // ↗
                case IdOrientation.Right:
                    // exp.x += baseSetup.expansionsSizeX due to calculation starting from point 0,0 of
                    // the square which requires fences.
                    exp.id += 0;
                    exp.x += baseSetup.expansionsSizeX + 1;
                    xExtent = 0.1;
                    yExtent = baseSetup.expansionsSizeY;
                    break;
                // ↙
                case IdOrientation.Left:
                    // exp.x -=1 is there to not mess up with calculations adding a negative extent.
                    exp.id += 1;
                    exp.x -= 0.1;
                    xExtent = 0.1;
                    yExtent = baseSetup.expansionsSizeY;
                    break;
                // ↖
                case IdOrientation.Up:
                    // exp.y += baseSetup.expansionsSizeY due to calculation starting from point 0,0 of
                    // the square which requires fences.
                    exp.id += 2;
                    exp.y += baseSetup.expansionsSizeY + 1;
                    xExtent = baseSetup.expansionsSizeX;
                    yExtent = 0.1;
                    break;
                // ↘
                case IdOrientation.Down:
                    // exp.y -=1 is there to not mess up with calculations adding a negative extent.
                    exp.id += 3;
                    xExtent = baseSetup.expansionsSizeX;
                    exp.y -= 0.1;
                    yExtent = 0.1;
                    break;
            }
            return {
                display: container,
                id: exp.id,
                volume: 3,
                x: exp.x,
                xExtent: xExtent,
                y: exp.y,
                yExtent: yExtent,
            };
        };
        _this.getObjects = function () { return _this.expansionGroups; };
        _this.postUpdate = function () {
            // Overridden in descendant classes
            _this.update$.next(true);
        };
        _this.mapState = function (state) {
            var fenceBundle = state.loading.bundles[IdAssetBundleCore.Fence] || { isLoaded: false };
            return {
                areAssetsLoaded: fenceBundle.isLoaded,
                buildingPlacement: state.playerBase.buildings,
                expansionInfo: selectExpansionInfo(state),
                fence: selectBuildingInfoByTypeId(state, IdBuilding.Fence),
                getCornerPillarIso: GetFenceCornerPillarIso,
                getPieceIso: GetFencePieceIso,
                getPillarIso: GetFencePillarIso,
            };
        };
        _this.mapDispatch = function (dispatch) { return ({
            onSelect: function (building, pos) {
                return dispatch(actionBuildingsSelect(building, pos));
            },
        }); };
        return _this;
    }
    return LayerPlayerBaseFence;
}(LayerPlayerBaseSurrounding));
export { LayerPlayerBaseFence };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/layers/LayerPlayerBaseFence.ts
// module id = 2214
// module chunks = 3